import { render, staticRenderFns } from "./kTomIndex.vue?vue&type=template&id=42ca2c9a&scoped=true&"
import script from "./kTomIndex.vue?vue&type=script&lang=js&"
export * from "./kTomIndex.vue?vue&type=script&lang=js&"
import style0 from "./kTomIndex.vue?vue&type=style&index=0&id=42ca2c9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca2c9a",
  null
  
)

export default component.exports